module.exports = "/images/discoverus-banner.png";